import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Footer } from "../sections/Closing";

export const LegalLayout = ({ title, subtitle, sections, testId }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid={testId}>
      <div className="sticky top-0 z-[100] border-b border-black/10" style={{ background: "rgba(255,255,255,0.85)", backdropFilter: "blur(14px)" }}>
        <div className="max-w-[740px] mx-auto px-6 py-4">
          <Link to="/" className="inline-flex items-center gap-2 font-mono-c text-[11px] tracking-[0.2em] text-black/60 hover:text-black transition-colors duration-200" data-testid="legal-back-home">
            <ArrowLeft size={14} /> BACK TO HOME
          </Link>
        </div>
      </div>
      <main className="max-w-[740px] mx-auto px-6 pt-16 pb-24">
        <h1 className="font-display font-bold uppercase text-3xl md:text-5xl tracking-tight mb-3" data-testid="legal-title">{title}</h1>
        <p className="font-mono-c text-[11px] tracking-[0.15em] text-black/40 mb-12">{subtitle}</p>
        <div className="space-y-10">
          {sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2 className="font-display font-semibold text-lg md:text-xl mb-3 text-[#181818]">
                <span className="font-mono-c text-[13px] mr-3" style={{ color: "#6D28D9" }}>{String(i + 1).padStart(2, "0")}</span>
                {s.h}
              </h2>
              {s.p.map((para, pi) => (
                <p key={pi} className="text-[15px] leading-[1.85] text-black/55 mb-3">{para}</p>
              ))}
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};
